// extracted by mini-css-extract-plugin
export default {"greeting":"Greeting_greeting__gRUHv"};